import React, { useEffect, useState } from 'react'
import { Panel } from 'rsuite'
import { useForm } from 'react-hook-form'
import GoalTenYear from '../goalTenYear/GoalTenYear'
import { handleOnChangeIsEdit } from '../../utils/widget'
import ComplianceObjectives from '../complianceObjectives/ComplianceObjectives'
import TargetGroupWidget from '../basicProjectInfo/targetSetting/TargetGroupWidget'
import ThePointWidget from '../basicProjectInfo/targetSetting/ThePointWidget'
import ChkAreaSettingWidget from '../basicProjectInfo/targetSetting/ChkAreaSettingWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function ConfirmActualResultWidget({ onSuccess = () => {}, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState()
  const [checkedFormSchema, setCheckedFormSchema] = useState()
  const [numberOfInstallment, setNumberOfInstallment] = useState(props.numberOfInstallment)
  const [isEditWidget, setIsEditWidget] = useState({})
  // const [isViewMode, setIsViewMode] = useState(props?.isViewMode || false)

  useEffect(() => {
    // console.log('props.schema', props.checked.overAll)
    console.log('ConfirmActualResultWidget props.schema => ', props.isEdit)
    setFormSchema(props?.schema)
    setCheckedFormSchema(props?.checked)
  }, [props?.checked?.overAll])

  return (
    <Panel
      shaded
      collapsible
      defaultExpanded
      header={'ยืนยันผลการดำเนินการจริง'}
      bordered
      style={{ marginBottom: 20 }}
    >
      {/* {!formSchema && <OverlayLoader />} */}

      {/*ความสอดคล้องของโครงการ กับเป้าหมายเชิงยุทธศาสตร์ 10 ปี*/}
      {formSchema?.goal?.goalTenYear && (
        <div>
          <GoalTenYear
            showCommandButton={
              checkedFormSchema?.goalTenYearChecked?.isViewMode
                ? false
                : !formSchema?.goal?.goalTenYear?.disabled
            }
            schema={formSchema?.goal?.goalTenYear}
            isConfirmActualResult={true}
            // isEdit={isEditWidget.goalTenYear}
            isEdit={true}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('goalTenYear', _isEdit, setIsEditWidget)
            }
            checked={checkedFormSchema?.goalTenYearChecked}
            numberOfInstallment={numberOfInstallment}
            onSuccess={onSuccess}
          />
        </div>
      )}

      {/* ความสอดคล้องของกิจกรรมกับวัตถุประสงค์ของตาม พ.ร.บ. ของ สสส. */}
      {formSchema?.goal?.complianceObjective && (
        <div style={{ marginTop: 20 }}>
          <ComplianceObjectives
            showCommandButton={
              checkedFormSchema?.complianceObjectiveChecked?.isViewMode
                ? false
                : !formSchema?.goal?.complianceObjective?.disabled
            }
            schema={formSchema?.goal?.complianceObjective}
            isConfirmActualResult={true}
            // isEdit={isEditWidget.complianceObjective}
            isEdit={true}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('complianceObjective', _isEdit, setIsEditWidget)
            }
            checked={checkedFormSchema?.complianceObjectiveChecked}
            numberOfInstallment={numberOfInstallment}
            onSuccess={onSuccess}
          />
        </div>
      )}

      {/* 3. กลุ่มเป้าหมายดำเนินการ */}
      {formSchema?.targetSettingArea?.targetGroups && (
        <div style={{ marginTop: 20 }}>
          <TargetGroupWidget
            showCommandButton={
              checkedFormSchema?.targetGroupsChecked?.isViewMode
                ? false
                : !formSchema?.targetSettingArea?.targetGroups?.disabled
            }
            schema={formSchema?.targetSettingArea?.targetGroups}
            isConfirmActualResult={true}
            // isEdit={isEditWidget.targetGroup}
            isEdit={true}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('targetGroup', _isEdit, setIsEditWidget)
            }
            checked={checkedFormSchema?.targetGroupsChecked}
            numberOfInstallment={numberOfInstallment}
            onSuccess={onSuccess}
          />
        </div>
      )}

      {/* 4. ประเด็น */}
      {formSchema?.targetSettingArea?.targetIssues && (
        <div style={{ marginTop: 20 }}>
          <ThePointWidget
            showCommandButton={
              checkedFormSchema?.targetIssuesChecked?.isViewMode
                ? false
                : !formSchema?.targetSettingArea?.targetIssues?.disabled
            }
            isConfirmActualResult={true}
            schema={formSchema?.targetSettingArea?.targetIssues}
            // isEdit={isEditWidget.targetIssue}
            isEdit={true}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('targetIssue', _isEdit, setIsEditWidget)
            }
            checked={checkedFormSchema?.targetIssuesChecked}
            numberOfInstallment={numberOfInstallment}
            onSuccess={onSuccess}
          />
        </div>
      )}

      {/* 5. พื้นที่ดำเนินการ (setting) */}
      {formSchema?.targetSettingArea?.targetSettings && (
        <div style={{ marginTop: 20 }}>
          <ChkAreaSettingWidget
            showCommandButton={
              checkedFormSchema?.targetSettingsChecked?.isViewMode
                ? false
                : !formSchema?.targetSettingArea?.targetSettings?.disabled
            }
            schema={formSchema?.targetSettingArea?.targetSettings}
            isConfirmActualResult={true}
            // isEdit={isEditWidget.targetSetting}
            isEdit={true}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('targetSetting', _isEdit, setIsEditWidget)
            }
            checked={checkedFormSchema?.targetSettingsChecked}
            numberOfInstallment={numberOfInstallment}
            onSuccess={onSuccess}
          />
        </div>
      )}
    </Panel>
  )
}
